import { Box, useTheme } from '@mui/material';

import { Typography } from '@zendesk/forethought-elements';

export const IndicatorStep = ({ message }: { message: string }) => {
  const theme = useTheme();

  return (
    <Box
      sx={{
        backgroundColor: theme.palette.background.paper,
        border: `1px solid ${theme.palette.colors.slate[100]}`,
        borderRadius: '5px',
        display: 'flex',
        justifyContent: 'flex-start',
        padding: '6px 12px',
        width: '100%',
      }}
    >
      <Typography color={theme.palette.colors.grey[600]} variant='font12Medium'>
        {message}
      </Typography>
    </Box>
  );
};
